import React, { FC } from "react";
export interface TextareaProps {
  label: string;
  name: string;
  placeholder?: string;
  register?: (ref: string, { required: boolean }) => void;
  errorMessage?: string;
}

export const Textarea: FC<TextareaProps> = ({
  label,
  name,
  placeholder,
  register,
  errorMessage,
}) => (
  <>
    <label htmlFor={name} className={register && "required"}>
      {label}
    </label>
    <textarea
      id={name}
      name={name}
      placeholder={placeholder}
      {...(register ? register(name, { required: true }) : {})}
    ></textarea>
    {!!errorMessage && <p className="error">{errorMessage}</p>}
  </>
);
